import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getQrCode } from '@ifeng-fe/container_content/common/client/services/api';
import { requestTongji } from '../../../../../../services/api';

class Share extends React.PureComponent {
    static propTypes = {
        config: PropTypes.object,
        shareInfo: PropTypes.object.isRequired,
    };

    static defaultProps = {
        config: {
            items: ['sina', 'wechat', 'qqzone', 'cof', 'qq'],
            display: 'hover',
            hover: 'filling',
            type: 'horizontal',
            methods: 'hover',
            tooltip: 'top',
        },
        shareInfo: {
            url: '',
            title: '',
            summary: '',
            picUrl: '',
        },
    };

    state = {
        hoverIndex: '',
        style: {},
        qrCodeShow: false,
    };

    handleMouseEnter = e => {
        const item = e.currentTarget.attributes['data-item'].value;
        const { methods } = this.props.config;
        const hoverIndex = Number(e.currentTarget.attributes['data-index'].value);

        this.setState({ hoverIndex });

        if ((item === 'wechat' || item === 'cof') && methods === 'hover') {
            this.getQrCode(e.currentTarget);
        }
    };

    handleMouseLeave = e => {
        const item = e.currentTarget.attributes['data-item'].value;
        const { qrCodeShow } = this.state;
        const { methods } = this.props.config;

        this.setState({ hoverIndex: '' });

        if ((item === 'wechat' || item === 'cof') && methods === 'hover') {
            this.setState({
                qrCodeShow: !qrCodeShow,
            });
        }
    };

    handleClick = e => {
        const item = e.currentTarget.attributes['data-item'].value;
        const { methods } = this.props.config;
        const { url, title, summary, picUrl } = this.props.shareInfo;

        if (item === 'sina') {
            window.open(
                `http://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(
                    title,
                )}&summary=${encodeURIComponent(summary)}&pic=${encodeURIComponent(picUrl)}`,
            );
            requestTongji('share', 'p_sina');
        } else if (item === 'qqzone') {
            requestTongji('share', 'p_qq');
            window.open(
                `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                    url,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(picUrl)}`,
            );
        } else if (item === 'qq') {
            window.open(
                `http://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
                    url,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(picUrl)}`,
            );
        } else if ((item === 'wechat' || item === 'cof') && methods === 'click') {
            this.getQrCode(e.currentTarget);
        }
    };

    getQrCode = async target => {
        const { qrCodeShow } = this.state;
        const { tooltip } = this.props.config;
        const { url } = this.props.shareInfo;
        let left = '';
        let top = '';

        if (!this.qrCode) {
            const data = await getQrCode(url);

            this.qrCode = data.qrcode_url;
        }

        if (tooltip === 'top') {
            left = target.offsetLeft - target.clientWidth / 2;
            top = target.offsetTop - 114;
        } else if (tooltip === 'bottom') {
            // left = target.offsetLeft - target.clientWidth / 2;
            // top = target.offsetTop + target.clientHeight;
            left = '30px';
            top = '35px';
        } else if (tooltip === 'left') {
            left = target.offsetLeft - 110;
            top = target.offsetTop - target.clientHeight + 9;
        } else if (tooltip === 'right') {
            left = target.offsetLeft + target.clientWidth;
            top = target.offsetTop - target.clientHeight + 9;
        }

        this.setState({
            style: { left, top },
            qrCodeShow: !qrCodeShow,
        });
    };

    getShareItem = () => {
        const { hoverIndex } = this.state;
        const { items, display, hover } = this.props.config;

        if (items) {
            return items.map((item, index) => (
                <span
                    key={index}
                    data-index={index}
                    data-item={item}
                    className={
                        index === hoverIndex ? `${styles[`${item}_${hover}`]}` : `${styles[`${item}_${display}`]}`
                    }
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={this.handleClick}
                />
            ));
        }
    };

    render() {
        const { style, qrCodeShow } = this.state;
        const { type, tooltip } = this.props.config;

        return (
            <div className={styles[type]}>
                {this.getShareItem()}
                {qrCodeShow ? (
                    <div className={styles.wexin_share} style={style}>
                        <div className={`${styles.wx} ${styles[tooltip]}`}>
                            <div className={styles.qrCode_box}>
                                <img src={this.qrCode} />
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export { Share };
export default Share;
